module.exports = __webpack_public_path__ + "img/45.5.COD.1df70f67.png";